/**
 * The demonstration sheet (SPEC_CAPTURE_UX_R2 §4) — the surface that "plays the demonstration without a tap" on a
 * first encounter, and the one the help sheet's "Show me" re-opens afterwards.
 *
 * A bottom sheet over the viewfinder with ONE way out ("Got it"): the camera keeps running underneath, nothing is
 * recording while it is up (a demonstration is not a shot), and the pills below are covered, not disabled — the
 * help sheet's own pattern.
 */

import { useT } from '@/i18n/runtime';
import { useEffect, useRef } from 'react';
import { Button } from '../components/Button';
import { ShowMe } from './ShowMe';
import { useDemoSheet } from './demoStore';

export function DemoSheet(): JSX.Element | null {
  const { t } = useT();
  const { open, close } = useDemoSheet();
  const closeRef = useRef<HTMLButtonElement>(null);

  // Focus lands on the control that cannot go wrong (the help sheet's rule).
  useEffect(() => {
    if (open) closeRef.current?.focus();
  }, [open]);

  if (!open) return null;
  return (
    <>
      <button type="button" className="sv-sheet-scrim is-showme" aria-label={t('sv.showme.close')} onClick={close} data-testid="showme-scrim" />
      <dialog open className="sv-sheet sv-showme-sheet" aria-labelledby="sv-showme-title" data-testid="showme-sheet" data-auto={open.auto ? 'true' : 'false'}>
        <div className="sv-sheet-head">
          <span className="sv-sheet-title" id="sv-showme-title">
            {t('sv.showme.title')}
          </span>
          <button ref={closeRef} type="button" className="sv-sheet-close" aria-label={t('sv.showme.close')} onClick={close} data-testid="showme-close">
            ×
          </button>
        </div>
        <ShowMe type={open.type} where="sheet" />
        <Button onClick={close} data-testid="showme-got-it">
          {t('sv.showme.gotIt')}
        </Button>
      </dialog>
    </>
  );
}
